module.exports = __webpack_public_path__ + "static/media/room4_3.b64b7e98.JPG";